import { EntryImage } from './entry-image';

export class ShowEntry {
    SubmissionID: string;

    FirstName: string;
    LastName: string;
    City: string;
    State: string;
    Country: string;
    Title: string;
    Price: number;
    UnframedWidth: number;
    UnframedHeight: number;
    FramedWidth: number;
    FramedHeight: number;
    Filename: string;
    TNFilename: string;
    JurorSelection: number;
    Award: string;
}
